import React, { useEffect, useState } from 'react';
import * as REQUEST from '../../common/request';

import AncientHomestay from './templates/AncientHomestay';
import RuralHomestay from './templates/RuralHomestay';
import StreetShop from './templates/StreetShop';

const PrintFireInspection = () => {
    const [recordData, setRecordData] = useState(null);

    const getDetail = async (id) => {
        const result = await REQUEST.get({
            url: '/fireInspectionRecord/get',
            data: { id }
        });

        if (result && result.data) {
            setRecordData(result.data);
        }
    };

    useEffect(() => {
        const query = new URLSearchParams(window.location.search);
        const id = query.get('data');

        if (id) {
            getDetail(id);
        }
    }, []);

    if (!recordData) {
        return (
            <div style={{ padding: 40 }}>
                加载中...
            </div>
        );
    }

    switch (recordData.formType) {

        case 'ancient_homestay':
            return <AncientHomestay data={recordData} />;

        case 'rural_homestay':
            return <RuralHomestay data={recordData} />;

        case 'street_shop':
            return <StreetShop data={recordData} />;

        default:
            return (
                <div style={{ padding: 40 }}>
                    未找到对应模板
                </div>
            );
    }
};

export default PrintFireInspection;